export default __webpack_public_path__ + "static/media/bold.00c3df72.svg";